import {FC} from "react";
import {EventComment} from "../../../../types/domain.ts";
import {isContentComment, isEditComment, isNewApproverComment} from "./utils.ts";
import {Flex, theme, Typography} from "antd";
import {
    AppstoreAddOutlined,
    CheckCircleFilled, DeleteOutlined,
    EditFilled, ExceptionOutlined, FileDoneOutlined, MailOutlined,
    RightCircleFilled,
    StopFilled,
    UserAddOutlined
} from "@ant-design/icons";
import {EDITED_FIELD_MAP} from "../../../../constants/constants.ts";
import {UserWithContacts} from "../../../../components/UserWithContacts/UserWithContacts.tsx";
import {CommentPure} from "./components/CommentPure/CommentPure.tsx";

type Props = {
    comment: EventComment;
}

export const Comment: FC<Props> = ({ comment }) => {
    const { token } = theme.useToken();

    if(isEditComment(comment)) {
        const { text, ending } = EDITED_FIELD_MAP[comment.field];

        return (
            <CommentPure
                user={comment.created_by}
                createdAt={comment.created_at}
                privateFor={comment.private_for}
                content={(
                    <Flex gap={4}>
                        <EditFilled style={{ color: token.colorTextTertiary }} />
                        Изменен{ending} {text}
                    </Flex>
                )}
            />
        )
    }

    if(isContentComment(comment)) {
        if(comment.type === 'return') {
            return (
                <CommentPure
                    user={comment.created_by}
                    createdAt={comment.created_at}
                    privateFor={comment.private_for}
                    content={(
                        <Flex gap={4}>
                            <StopFilled style={{ color: token.colorError }} />
                            <Typography.Text type="danger">Не согласовано: {comment.content}</Typography.Text>
                        </Flex>
                    )}
                />
            )
        }

        if(comment.type === 'request_cancel') {
            return (
                <CommentPure
                    user={comment.created_by}
                    createdAt={comment.created_at}
                    privateFor={comment.private_for}
                    content={(
                        <Flex gap={4}>
                            <DeleteOutlined style={{ color: token.colorError }} />
                            <Typography.Text type="danger">Запрошена отмена: {comment.content}</Typography.Text>
                        </Flex>
                    )}
                />
            )
        }

        if(comment.type === 'request_vatrus') {
            return (
                <CommentPure
                    user={comment.created_by}
                    createdAt={comment.created_at}
                    privateFor={comment.private_for}
                    content={(
                        <Flex gap={4}>
                            <MailOutlined style={{ color: token.colorTextTertiary }} />
                            <Typography.Text>
                                Запрошена публикация на VATRUS: <Typography.Link href={comment.content}>ссылка</Typography.Link>
                            </Typography.Text>
                        </Flex>
                    )}
                />
            )
        }

        return (
            <CommentPure
                user={comment.created_by}
                createdAt={comment.created_at}
                content={comment.content}
                privateFor={comment.private_for}
            />
        )
    }

    if(comment.type === 'approve') {
        return (
            <CommentPure
                user={comment.created_by}
                createdAt={comment.created_at}
                privateFor={comment.private_for}
                content={(
                    <Flex gap={4}>
                        <CheckCircleFilled style={{ color: token.colorSuccess }} />
                        <Typography.Text type="success">Согласовано</Typography.Text>
                    </Flex>
                )}
            />
        )
    }

    if(comment.type === 'created') {
        return (
            <CommentPure
                user={comment.created_by}
                createdAt={comment.created_at}
                privateFor={comment.private_for}
                content={(
                    <Flex gap={4}>
                        <AppstoreAddOutlined style={{ color: token.colorTextTertiary }} />
                        Инициировано
                    </Flex>
                )}
            />
        )
    }

    if(comment.type === 'vatsim') {
        return (
            <CommentPure
                user={comment.created_by}
                createdAt={comment.created_at}
                privateFor={comment.private_for}
                content={(
                    <Flex gap={4}>
                        <FileDoneOutlined style={{ color: token.colorTextTertiary }} />
                        Опубликовано на VATSIM
                    </Flex>
                )}
            />
        )
    }

    if(comment.type === 'request_vatsim') {
        return (
            <CommentPure
                user={comment.created_by}
                createdAt={comment.created_at}
                privateFor={comment.private_for}
                content={(
                    <Flex gap={4}>
                        <ExceptionOutlined style={{ color: token.colorTextTertiary }} />
                        Запрашивается подтверждение публикации на VATSIM
                    </Flex>
                )}
            />
        )
    }

    if(isNewApproverComment(comment)) {
        return (
            <CommentPure
                user={comment.created_by}
                createdAt={comment.created_at}
                privateFor={comment.private_for}
                content={(
                    <Flex gap={4}>
                        <UserAddOutlined style={{ color: token.colorTextTertiary }} />
                        Добавлен согласующий: <UserWithContacts user={comment.user} />
                    </Flex>
                )}
            />
        )
    }

    return (
        <CommentPure
            user={comment.created_by}
            createdAt={comment.created_at}
            privateFor={comment.private_for}
            content={(
                <Flex gap={4}>
                    <RightCircleFilled style={{ color: token.colorTextTertiary }} />
                    Перенаправлено
                </Flex>
            )}
        />
    )
}